export default __webpack_public_path__ + "static/media/the_bruins.36a2e734.jpg";